module.exports = __webpack_public_path__ + "static/img/home-pub-rj.459021d1.jpg";